// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.tab-selector-component .tab-selector-button[data-v-5aa7bfb5] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 36px;\n  height: 36px;\n  font-size: 22px;\n  color: #001978;\n}\n.tab-selector-component .tab-selector-button[disabled=disabled][data-v-5aa7bfb5] {\n  color: #999999;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
